import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { bool, number } from "yup";
import {
  fetchCountyData,
  fetchStateData,
} from "../../redux/actions/dataActions";
import { GetPoketProfileList } from "../../redux/actions/poketProfileAction";
import DropDown from "../../components/DropDown";
import Pagination from "../../components/pagination";
import { hasPermission } from "../../config/permissionUtils";
const PoketProfile: FC = () => {
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions, loading, error } = usePermissions();
  const dispatch = useDispatch<AppDispatch>();
  const [CurrentPage, SetCurrentPage] = useState(1);
  const [pgsize, Setpgsize] = useState(10);
  const [state, setstate] = useState<Array<{ label: string; value: string }>>(
    []
  );
  const [County, setCounty] = useState<Array<{ label: string; value: string }>>(
    []
  );
  const [poket_user_name, set_poket_user_name] = useState("");
  const [farm_Id, set_farm_Id] = useState("");
  const [set_state, set_state_Option] = useState<string>("");
  const [county_Option, set_county_Option] = useState<string>("");
  const [TotalRecords, setTotalRecords] = useState();
  const [contactList, setcontactList] = useState({
    data: [],
    pageIndex: number,
    pageSize: number,
    totalrecords: number,
    totalPage: number,
    hasPreviousPage: bool,
    hasNextPage: bool,
  });

  useEffect(() => {
    fetchStateOptions();
    fetchCountyOptions();
    searchPoketProfile();
  }, [CurrentPage, set_state, county_Option, farm_Id, poket_user_name]);

  const fetchStateOptions = async () => {
    const payload = {
      stateid: null,
      statename: null,
    };
    dispatch(
      fetchStateData(payload, (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          const formattedOptions = response.data.map((item: any) => ({
            label: item.statename,
            value: item.statename.toString(),
          }));
          setstate(formattedOptions);
        }
      })
    );
  };

  const fetchCountyOptions = async () => {
    const payload = {
      countyid: null,
      countyname: null,
    };
    dispatch(
      fetchCountyData(payload, (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          const formattedOptions = response.data.map((item: any) => ({
            label: item.countyname,
            value: item.countyname.toString(),
          }));
          setCounty(formattedOptions);
        }
      })
    );
  };

  const searchPoketProfile = () => {
    var payload = {
      PageIndex: CurrentPage,
      PageSize: pgsize,
      SkipRow: pgsize * (CurrentPage - 1),
      SortBy: null,
      SortOrder: "desc",
      id: "",
      county: county_Option,
      state: set_state,
      poket_user_name: poket_user_name,
      farm_id: farm_Id,
    };
    dispatch(
      GetPoketProfileList(payload, (response: any) => {
        if (response.status != 500) {
          setcontactList(response);
          setTotalRecords(response.totalrecords);
        }
      })
    );
  };
  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4">
          <div className="container">
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <div className="loginHd mb-1">
                  <span className="d-block">Poket Profile</span>
                </div>
                <div className="bradcrumb">
                  <NavLink to="/dashboard">Dashboard</NavLink> &gt; Poket
                  Profile
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="filterCon">
          <div className="container">
            <div className="d-flex flex-wrap align-items-center pt-3 pb-3">
              <div className="searchBy">Search By</div>
              <ul className="d-flex flex-wrap filterBox">
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Farm ID</span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) => set_farm_Id(event.target.value)}
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">Poket User Name</span>
                    <input
                      type="text"
                      className="filterInput"
                      onChange={(event) =>
                        set_poket_user_name(event.target.value)
                      }
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">State</span>
                    <DropDown
                      options={state}
                      onChange={(event) => set_state_Option(event.target.value)}
                      className="filterInput"
                      Title="Select State"
                    />
                  </div>
                </li>
                <li className="col-6 col-sm-3">
                  <div className="position-relative">
                    <span className="field">County</span>
                    <DropDown
                      options={County}
                      onChange={(event) =>
                        set_county_Option(event.target.value)
                      }
                      className="filterInput"
                      Title="Select County"
                    />
                  </div>
                </li>
                <li className="btn">
                  <button type="button">
                    <span className="material-icons">search</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 mt-2 whtBg">
          <div className="container">
            <div className="tableBox">
              <table>
                <thead></thead>
                <tr>
                  <th>Farm ID</th>
                  <th>Farm Name</th>
                  <th>Poket User Name</th>
                  <th>State</th>
                  <th>County</th>
                  <th>Type of Operation Rolled</th>
                  {hasPermission(
                    permissions,
                    roleid,
                    "Poket Profile",
                    "view"
                  ) && <th>Action</th>}
                </tr>
                {contactList.data && (
                  <tbody>
                    {contactList.data.map((item: any) => (
                      <tr key={"id" + item.id}>
                        <td>{item.farm_id}</td>
                        <td>{item.farm_name}</td>
                        <td>{item.username}</td>
                        <td>{item.state}</td>
                        <td>{item.county}</td>
                        <td>{item.type_of_operation_rolled}</td>
                        <td>
                          <div className="actionbtn d-flex">
                            {hasPermission(
                              permissions,
                              roleid,
                              "Poket Profile",
                              "view"
                            ) && (
                              <NavLink
                                to={{
                                  pathname: "/PoketProfile/view/" + item.id,
                                }}
                                title="View"
                              >
                                <span className="material-icons-outlined">
                                  visibility
                                </span>
                              </NavLink>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
              <div className="totalResul">{TotalRecords}</div>
              <Pagination
                GoToPage={(value: number) => {
                  SetCurrentPage(value);
                }}
                PageIndex={Number(contactList.pageIndex)}
                TotalPages={Number(contactList.totalPage)}
                hasNextPage={Boolean(contactList.hasNextPage)}
                hasPreviousPage={Boolean(contactList.hasPreviousPage)}
              />
              <div></div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PoketProfile;
